import React from 'react';
import { cn } from '@/lib/utils';

interface HeadingProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  children: React.ReactNode;
  className?: string;
}

export function Heading({
  as: Component = 'h1',
  children,
  className,
  ...props
}: HeadingProps & React.HTMLAttributes<HTMLHeadingElement>) {
  const sizeClasses = {
    h1: 'text-3xl font-bold',
    h2: 'text-2xl font-semibold',
    h3: 'text-xl font-semibold',
    h4: 'text-lg font-medium',
    h5: 'text-base font-medium',
    h6: 'text-sm font-medium',
  };

  return (
    <Component
      className={cn(sizeClasses[Component], className)}
      {...props}
    >
      {children}
    </Component>
  );
} 